import { Button, Dropdown } from 'antd';
import type { MenuProps } from 'antd';
import React from 'react';

import type { PortfolioProjectRow } from '@/api/portfolio/api';
import { VerticalEllipsisIcon } from '@/icons';

export interface PortfolioRowActionsProps {
  row: PortfolioProjectRow;
  onAddSharePointLink: (row: PortfolioProjectRow) => void;
}

export const PortfolioRowActions: React.FC<PortfolioRowActionsProps> = ({
  row,
  onAddSharePointLink,
}) => {
  const menuItems: MenuProps['items'] = [
    {
      key: 'add-sharepoint-link',
      label: 'Add SharePoint link',
      onClick: ({ domEvent }) => {
        domEvent.stopPropagation();
        onAddSharePointLink(row);
      },
    },
  ];

  return (
    <Dropdown menu={{ items: menuItems }} trigger={['click']} placement="bottomRight">
      <Button
        type="text"
        size="small"
        icon={<VerticalEllipsisIcon />}
        aria-label="Row actions"
        onClick={(event) => event.stopPropagation()}
      />
    </Dropdown>
  );
};

export default PortfolioRowActions;
